import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _deepEqual from 'deep-equal';
export var ChildUtils = /*#__PURE__*/function () {
  function ChildUtils(factory) {
    _classCallCheck(this, ChildUtils);
    this.factory = factory;
  }
  _createClass(ChildUtils, [{
    key: "create",
    value: function create(value, params) {
      return this.factory.create(value, params);
    }
  }, {
    key: "clone",
    value: function clone(value, params) {
      return this.factory.create(this.factory.serialize(value), params);
    }
  }, {
    key: "deepEqual",
    value: function deepEqual(a, b) {
      if (_typeof(a) !== 'object' || _typeof(b) !== 'object') return a === b;
      if (Object.getPrototypeOf(a).constructor !== Object.getPrototypeOf(b).constructor) return false;
      return _deepEqual(this.factory.serialize(a), this.factory.serialize(b));
    }
  }]);
  return ChildUtils;
}();